// Taken from http://boedesign.com/blog/2011/03/31/outerhtml-plugin-for-jquery/
import jQuery from 'jquery';

export default (function($) {
  $.fn.outerHTML = function() {
    // IE, Chrome & Safari will comply with the non-standard outerHTML, all others (FF) will have a fall-back for cloning
    var getOuter = function(el) {
      var div = document.createElement('div');
      div.appendChild(el.cloneNode(true));
      var contents = div.innerHTML;
      div = null;
      return contents;
    };

    return !this.length ? this : this[0].outerHTML || getOuter(this[0]);
  };
})(jQuery);
